import {combineReducers} from 'redux';
import {categoriesReducer} from './categories/reducer';
import {currentUserReducer} from './current_user/reducer';
import {customersReducer} from './customers/reducer';
import {employeesReducer} from './employees/reducer';
import {workItemsReducer} from './work_items/reducer';
import {projectsReducer} from './projects/reducer';
import {statusReducer} from './status/reducer';
import {workTrackersReducer} from './work_trackers/reducer';

export default combineReducers({
  categories: categoriesReducer,
  currentUser: currentUserReducer,
  customers: customersReducer,
  employees: employeesReducer,
  projects: projectsReducer,
  status: statusReducer,
  workItems: workItemsReducer,
  workTrackers: workTrackersReducer
});
